import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dropdown"
export default class extends Controller {
  static targets = ["menu", "submenu"]

  connect() {
    this.closeHandler = this.close.bind(this)
  }

  toggle(event) {
    event.stopPropagation()
    if (this.menuTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.menuTarget.classList.remove("hidden")
    // Close on outside click
    setTimeout(() => {
      document.addEventListener("click", this.closeHandler, true)
    }, 0)
  }

  close(event) {
    if (event && this.element.contains(event.target)) {
      return
    }
    this.menuTarget.classList.add("hidden")
    // Close all submenus when main menu closes
    this.submenuTargets.forEach(submenu => {
      submenu.classList.add("hidden")
    })
    document.removeEventListener("click", this.closeHandler, true)
  }

  toggleSubmenu(event) {
    event.stopPropagation()
    const submenuContainer = event.currentTarget.closest("[data-dropdown-submenu]")
    if (submenuContainer) {
      const submenu = submenuContainer.querySelector(".group-hover\\:block")
      if (submenu) {
        // Close other submenus
        this.submenuTargets.forEach(sm => {
          if (sm !== submenu) {
            sm.classList.add("hidden")
          }
        })
        // Toggle current submenu
        submenu.classList.toggle("hidden")
      }
    }
  }

  disconnect() {
    document.removeEventListener("click", this.closeHandler)
  }
}

